import { jsx as e } from "react/jsx-runtime";
import { Icon as o } from "./index.es147.js";
const n = {
  color: "gray",
  size: 16
}, i = {
  name: {
    iconComponent: /* @__PURE__ */ e(o, { type: "User", ...n }),
    type: "text"
  },
  phoneNumber: {
    iconComponent: /* @__PURE__ */ e(o, { type: "DeviceMobileSpeaker", ...n }),
    type: "phoneNumber"
  },
  businessNumber: {
    iconComponent: /* @__PURE__ */ e(o, { type: "Phone", ...n }),
    type: "phoneNumber"
  },
  email: {
    iconComponent: /* @__PURE__ */ e(o, { type: "Envelope", ...n }),
    type: "email"
  },
  linkedin: {
    iconComponent: /* @__PURE__ */ e(o, { type: "LinkedinLogo", ...n }),
    type: "link"
  },
  operatingRegion: {
    iconComponent: /* @__PURE__ */ e(o, { type: "MapPinArea", ...n }),
    type: "text"
  }
};
export {
  i as DETAIL_TO_PROPERTIES
};
//# sourceMappingURL=index.es5480.js.map
